import { Link } from "react-router-dom";
import Badge from "./General/Badge";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  getPolicyType,
  stringFormattingToCurrency,
  getName,
  getBadgeText,
  getBadgeClassByPolicyStatus,
} from "js/formatting";
import { useSelector } from "react-redux";
import {
  isAgentPortal,
  isAllowedToMakeCCPayment,
  isMITPolicy,
  isOldAlicUlPolicy,
  isWholeLifePolicy,
} from "js/utilities";
import { useTranslation } from "react-i18next";
import { getFinancials } from "service/policy/getFinancials";

export default function PolicyCard({ data }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const [policyCard, setPolicyCard] = useState({});
  const [pastDue, SetPastDue] = useState();
  const [banner, setBanner] = useState();
  const [cashValue, setCashValue] = useState();
  useEffect(() => {
    let primaryOwner = data?.parties?.find(
      (x) => x.person?.taxId === user.identityNumber
    );
    if (isAgentPortal())
      primaryOwner = data?.parties?.find(
        (x) => x.person?.type?.toLowerCase() === "primary owner"
      );
    let insured = data?.parties?.find(
      (x) => x.person?.type?.toLowerCase() === "insured"
    );
    if (isWholeLifePolicy(data?.product?.type) || isOldAlicUlPolicy(data))
      getFinancials(data).then((financials) => {
        setCashValue(financials.cashValues[0]);
      });

    setPolicyCard({
      oldPolicy: data.oldPolicy,
      contractID: data.contractID,
      policyStatus: data.status,
      nameTitle: primaryOwner?.person?.nameTitle,
      cardTitle: `${data ? `${getPolicyType(data)} - ` : ""} ${getName(
        primaryOwner?.person
      )}`,
      faceAmount: data?.cashValue?.currentFaceAmount,
      productName: data?.product?.description ? data?.product?.description : "",
      productType: data?.product?.type ? data?.product?.type : "",
      modalPremiumAmountTotal: data?.modalPremiumAmountTotal
        ? data?.modalPremiumAmountTotal
        : "",
      estimatedSurrenderValue: data?.cashValue?.estimatedSurrenderValue
        ? data?.cashValue?.estimatedSurrenderValue
        : "0.0",
      insured: getName(insured?.person),
      status: getBadgeClassByPolicyStatus(data),
      statusText: getBadgeText(data),
    });
    SetPastDue(getTotalDays(data?.premiumDueDate) + 1);
    setBanner(pastDue > 0 && "risk");
  }, [user, data]);

  const getTotalDays = (date) => {
    let difference = new Date() - new Date(date).getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24)) + 1;
    return TotalDays;
  };

  return (
    <div className="ui-grid-item">
      {data?.status && data?.status !== "" && (
        <div
          className={`ui-badge-bar ui-badge-bar-${getBadgeClassByPolicyStatus(
            data
          )}`}
        ></div>
      )}
      <div className="ui-grid-layout">
        <div className="ui-policy-col-01">
          <div className="text-xxs text-theme-text-tertiary">
            {t("CustomerPolicies-policy-number")} {policyCard.oldPolicy}
          </div>
          <div className="ui-grid-name">
            <div className="text-lg font-semibold text-theme-text-secondary">
              {policyCard.cardTitle}
            </div>
            {data?.status && data?.status !== "" && (
              <Badge
                status={policyCard?.status}
                statusText={policyCard?.statusText}
                srPrefix={t("CustomerPolicies-policy")}
              />
            )}
          </div>
        </div>

        <div className="ui-policy-col-02">
          <div className="text-xs text-theme-text-tertiary">
            {t("CustomerPolicies-insured-name")}
          </div>
          <div className="text-sm font-semibold text-theme-text-secondary">
            {policyCard?.insured}
          </div>
        </div>

        {!isAgentPortal() && !isMITPolicy(data) && (
          <div className="ui-policy-col-03">
            <div className="text-xs text-theme-text-tertiary">
              {t("CustomerPolicies-coverage")}
            </div>
            <div className="text-sm font-semibold text-theme-text-secondary">
              {stringFormattingToCurrency(policyCard?.faceAmount)}
            </div>
          </div>
        )}

        <div className="ui-policy-col-04">
          <div className="text-xs text-theme-text-tertiary">
            {t("CustomerPolicies-product-name")}
          </div>
          <div className="text-sm font-semibold text-theme-text-secondary">
            {policyCard?.productName}
          </div>
        </div>
        {(isWholeLifePolicy(policyCard?.productType) ||
          isOldAlicUlPolicy(data)) && (
          <div className="ui-policy-col-05">
            <div className="text-xs text-theme-text-tertiary">
              {t("CustomerPolicies-cashSurrenderValue")}
            </div>
            <div className="text-sm font-semibold text-theme-text-secondary">
              {stringFormattingToCurrency(cashValue?.estimatedSurrenderValue)}
            </div>
          </div>
        )}

        <div className="ui-policy-col-06 text-right">
          {data?.status && data?.status !== "" && (
            <Badge
              status={policyCard.status}
              statusText={policyCard?.statusText}
              srPrefix="Policy"
            />
          )}
          {pastDue > 0 &&
            policyCard?.modalPremiumAmountTotal > 0 &&
            isAllowedToMakeCCPayment(data, "onetimepayment") && (
              <button
                className="ui-btn-primary"
                onClick={() => {
                  if (isAgentPortal())
                    navigate(`/payment/${policyCard?.contractID}`);
                  else navigate(`/payment/make-a-payment`);
                }}
              >
                {t("CustomerPolicies-make-a-payment")}
                <span className="sr-only">
                  {" "}
                  for policy {policyCard?.contractID}
                </span>
              </button>
            )}
          {(pastDue <= 0 || policyCard?.modalPremiumAmountTotal === 0) && (
            <button
              className="ui-btn-secondary"
              onClick={() => navigate(`/policies/${policyCard?.contractID}`)}
            >
              {t("CustomerPolicies-view-details")}
              <span className="sr-only">
                {" "}
                for policy {policyCard?.contractID}
              </span>
            </button>
          )}
        </div>
      </div>
      <Link
        className="ui-btn-arrow-details"
        aria-label={` View details for policy ${policyCard?.contractID}`}
        to={`/policies/${policyCard?.contractID}`}
      >
        <svg
          className="ui-icon w-8 h-8"
          focusable="false"
          aria-hidden="true"
          role="presentation"
        >
          <use href="#ui-icon-next"></use>
        </svg>
      </Link>
    </div>
  );
}
